import { CommonModule } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getPlanesData, getVehicleData } from '../../helpers/dataLayerHelpers';
import { getSessionId } from '../../helpers/storageUtils';
import { Cotizacion } from '../../Models/cotizacion';
import { CrearCotizacion } from '../../Models/crearCotizacion';
import { DatosGenerales } from '../../Models/datosGenerales';
import { DatosPlanes } from '../../Models/datosPlanes';
import { PipesModule } from '../../pipes/pipes.module';
import { CotizacionService } from '../../services/Cotizacion/cotizacion.service';
import { DataLayerService } from '../../services/DataLayer/data-layer.service';
import { LeadsService } from '../../services/Leads/leads.service';
import { TiempoInactivoService } from '../../services/TiempoInactivo/tiempo-inactivo.service';
import { selectCotizacion } from '../../storage/Cotizacion/cotizacion.selectors';
import { selectData } from '../../storage/Lead/data.selectors';
import { selectPlanes } from '../../storage/Planes/planes.selector';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-pago-aprobado-no-ap',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent, PipesModule, CommonModule],
  templateUrl: './pago-aprobado-no-ap.component.html',
  styleUrl: './pago-aprobado-no-ap.component.scss',
})
export class PagoAprobadoNoApComponent implements OnInit {
  VariableSantiago = 'Santiago Salamanca';
  public planes!: Cotizacion;
  public planesTemp: Cotizacion | undefined;
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;

  datosCotizacion: CrearCotizacion | null = null;
  datosCotizacion$: Observable<CrearCotizacion | null>;

  sessionId = '';
  public fecha = '';
  date: Date = new Date();

  tipoPago: string | undefined;
  PagoPlan: any;
  valorAntesE = 0;
  valorAntesT = 0;
  valorAntesP = 0;

  valorAPagar = 0;
  valorSubTotal = 0;
  valorMes = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    private store: Store,
    private leadServices: LeadsService,
    private tiempoInactivo: TiempoInactivoService,
    private cotizacion: CotizacionService,
    private dataLayerService: DataLayerService,
  ) {
    console.log('pago aprobado');
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);
    this.datosCotizacion$ = this.store.select(selectCotizacion);
  }
  async ngOnInit() {
    this.fecha = `${this.date.getFullYear()}-${this.date.getMonth() + 1}-${
      this.date.getDate() + 1
    }`;
    this.sessionId = getSessionId().toString();
    console.log('PRUEBA');

    await this.getParamPrepolicyId();

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });

    this.datosPlanes$.subscribe((data) => {
      // this.planesTemp = data?.planes;
      this.datosPlanes = data;
    });

    if (this.planesTemp) {
      this.planes = this.planesTemp;
    }

    this.datosCotizacion$.subscribe((data) => {
      this.datosCotizacion = data;
    });

    this.pushDataLayer('Pageview');

    this.tipoPago = this.datosPlanes?.payment_frequency;

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanEsencial') {
      const valorE = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesE = this.PagoPlan.priceMensual.amount + valorE;
      this.valorSubTotal = this.valorAntesE;
    }

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanTotal') {
      const valorT = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesT = this.PagoPlan.priceMensual.amount + valorT;
      this.valorSubTotal = this.valorAntesT;
    }

    if (this.datosPlanes?.selected_plan === 'MOTOS_PlanPremium') {
      const valorP = this.PagoPlan.priceMensual.amount * 0.2;
      this.valorAntesP = this.PagoPlan.priceMensual.amount + valorP;
      this.valorSubTotal = this.valorAntesP;
    }

    this.valorMes = this.PagoPlan.priceMensual.amount;
    this.valorAPagar =
      this.tipoPago === 'Monthly'
        ? this.PagoPlan.priceMensual.amount
        : this.PagoPlan.priceAnual.amount;
  }

  private getParamPrepolicyId(): void {
    this.route.queryParams.subscribe((params) => {
      const prepolicyid = params['prepolicyid'];
      if (prepolicyid) {
        console.log('prepolicyid en PagoAprovado:', prepolicyid);
        this.cotizacion.getCotizacion(this.sessionId, prepolicyid).subscribe(
          (data) => {
            this.planes = data;
            console.log('data en PagoAprovado:', data);
          },
          (error) => {
            console.log('error en PagoAprovado:', error);
          },
        );
      }
    });
  }
  entendido() {
    this.pushDataLayer('Button', 'Entendido');
    window.location.href = 'https://www.sura.co/';
  }

  pushDataLayer(ecom_item: 'Pageview' | 'Button' | undefined, ecom_subitem = ''): void {
    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_6_pago_aprobado',
      ecom_tipo: 'Moto',
      ecom_item,
      ecom_subitem,
      ecom_pantalla: 'Pago aprobado',
      user_id: this.sessionId,
      ...getVehicleData(this.datosGenerales),
      ...getPlanesData(this.datosPlanes),
      dueño_paga_seguro: this.datosCotizacion?.dueño_paga_seguro || 'Si',
    });
  }
}
